$(function() {
  // Show the first 3 elements initially
  $(".about-customer-bill-rights-main .about-customer-bill-block .about-customer-bill-block-inner--").slice(0, 3).show();
  
  // Load more button functionality
  $("#loadMore").on('click', function(e) {
    e.preventDefault();
    // Show the next 4 hidden elements
    $(".about-customer-bill-rights-main .about-customer-bill-block .about-customer-bill-block-inner:hidden").slice(0, 4).slideDown();
    
    // If there are no more hidden elements, hide the load more button and show the load less button
    if ($(".about-customer-bill-rights-main .about-customer-bill-block .about-customer-bill-block-inner:hidden").length === 0) {
      $("#loadLess").fadeIn('slow');
      $("#loadMore").hide();
    }
  });

  // Initialize slick carousel
  $('.about-customer-bill-rights-main .about-customer-bill-block').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          centerMode: true,
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  });
});
